import { Link } from 'react-router-dom'
import { ProgressBarWheelIcon } from '../ProgressBarWheelIcon/ProgressBarWheelIcon'
import { RoutePaths } from 'src/routes/routePaths'
import { useIsVariantEnabled } from 'src/hooks/useIsVariantEnabled'
import { FF_CORE_UX } from 'src/constants/feature-flags'
import { useOnboardingStatus } from 'src/hooks/useOnboardingStatus'
import { userOnboardingModalAtom } from 'src/atoms/modals/userOnboardingModal.atom'
import { useSetAtom } from 'jotai'

interface OnboardingHubProgressLinkProps {
  dark?: boolean
  className?: string
  'data-testid'?: string
}

export function OnboardingHubProgressLink({
  dark = false,
  className = '',
  'data-testid': dataTestId = 'onboarding-link'
}: Readonly<OnboardingHubProgressLinkProps>) {
  const { progress } = useOnboardingStatus()
  const isCoreUxEnabled = useIsVariantEnabled(
    FF_CORE_UX.name,
    FF_CORE_UX.variantsMap.treatment1
  )
  const setUserOnboardingModal = useSetAtom(userOnboardingModalAtom)

  const handleClick = (e: React.MouseEvent) => {
    if (!isCoreUxEnabled) {
      e.preventDefault()
      setUserOnboardingModal({ isOpen: true })
    }
  }

  return (
    <Link
      to={RoutePaths.ONBOARDING_HUB}
      data-testid={dataTestId}
      className={className}
      onClick={handleClick}>
      <ProgressBarWheelIcon progress={progress} dark={dark} />
      <span>Your Journey</span>
    </Link>
  )
}
